import { Box,Typography } from "@material-ui/core";
const NotFoundFallback = (props) => {
    return (
      <Box
        style={{
          width: "100%",
          height: "23.5rem",
          maxHeight: "23.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          component={"p"}
          style={{ fontWeight: 800, fontSize: "1.1rem" }}
        >
          {props.text?props.text:"Data not found"}
        </Typography>
      </Box>
    );
  };
  export default NotFoundFallback;